<!--
 * @Author: liangxl 1316613426@qq.com
 * @Date: 2022-11-18 14:03:50
 * @LastEditors: liangxl 1316613426@qq.com
 * @LastEditTime: 2022-11-21 17:18:58
 * @FilePath: \py-sps-train-platform\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
import { phoneUrl } from '@/config/defaultSysUrls'

export default {
  name: 'App',
  provide (){
    return {
      reload:this.reload
    }
  },
  data(){
    return {
      isRouterAlive:true
    }
  },
  mounted(){
    if (this._isMobile()){
      var locHref = window.location.href
      if (locHref.indexOf("/home/Curriculum") != -1){
        var strs = locHref.split("/")
        window.location.href = phoneUrl + '/pages/course/course?courseId=' + strs[strs.length - 1]
        return false
      }
      window.location.href = phoneUrl + '/pages/index/index/choiceTrain'
    }
  },
  methods:{
    reload (){
      this.isRouterAlive = false
      this.$nextTick(function(){
          this.isRouterAlive = true
      })
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height:100%;
}
.el-menu--horizontal > .el-menu-item.is-opened {
  background-color: red !important;
  z-index: 100000;
}

html,body{height:100% !important;}
</style>



// WEBPACK FOOTER //
// src/App.vue